import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFixedHeight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFixedHeight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.3 18a.75.75 0 0 0 0-1.5H4.7a.75.75 0 0 0 0 1.5zM10 13.998a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 1.5 0v6.5a.75.75 0 0 1-.75.75m6.05-11.25a.75.75 0 0 1-.75.75H4.7a.75.75 0 0 1 0-1.5h10.6a.75.75 0 0 1 .75.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFixedHeight20);
